import React from "react";
import { Container } from "./AccentAlert.styles";

export type AccentAlertProps = {
  children: React.ReactNode
}

export default function AccentAlert({ children }: AccentAlertProps) {
  return (
    <Container>{children}</Container>
  )
}
